export const BOOK_DEMO_URL = "https://cal.com/strelve/book-a-demo";
export const BOOK_CALL_URL =
  "https://cal.com/strelve/talk-through-your-options";
